module.exports = __webpack_public_path__ + "employees-21b62107/503-4047d3143a02e6fe213c64b20551cbdf.svg";